export default {
    feedbackPadding: '4px 0 0 2px',
    feedbackHeightSmall: '24px',
    feedbackHeightMedium: '24px',
    feedbackHeightLarge: '26px',
    feedbackFontSizeSmall: '13px',
    feedbackFontSizeMedium: '14px',
    feedbackFontSizeLarge: '14px',
    labelFontSizeLeftSmall: '14px',
    labelFontSizeLeftMedium: '14px',
    labelFontSizeLeftLarge: '15px',
    labelFontSizeTopSmall: '13px',
    labelFontSizeTopMedium: '14px',
    labelFontSizeTopLarge: '14px',
    labelHeightSmall: '24px',
    labelHeightMedium: '26px',
    labelHeightLarge: '28px',
    labelPaddingVertical: '0 0 8px 2px',
    labelPaddingHorizontal: '0 12px 0 0',
    labelTextAlignVertical: 'left',
    labelTextAlignHorizontal: 'right'
};
